import * as t from "io-ts"

export const CustomerType = t.union([
  t.literal(`COMMERCIAL`),
  t.literal(`TRAINING`),
  t.literal(`RECREATIONAL`),
  t.literal(`ENTERPRISE`),
])
